module.exports = __webpack_public_path__ + "img/Foto_Press_release_DAB_Pemkot_Bogor.80556b36.jpeg";